import React from 'react'
import ModelComponent from '../../../components/Modal'
import * as Yup from 'yup'
import { Formik, Form, ErrorMessage } from 'formik'
import { _integerRegex_ } from '../../../lib/Regex'
import axiosProvider from '../../../lib/AxiosProvider'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { Button, InputGroup, Form as frm } from 'react-bootstrap'
import TextError from '../../../components/TextError'
import { _SwalDelete, _exception } from '../../../lib/exceptionMessage'
import Swal from 'sweetalert2'
import {
  changeHandler,
  encodedSearchText,
  fetchCalculation,
  fetchOrderData,
  generateSawbNumber,
  showToast
} from '../../../lib/AllGlobalFunction'
import ReactSelect from '../../../components/ReactSelect'

const ShipOrder = ({
  modalShow,
  setModalShow,
  getOrderItems,
  setLoading,
  initialValues,
  setInitialValues,
  initVal,
  setToast,
  toast,
  filterDetails
}) => {
  const { userInfo } = useSelector((state) => state?.user)
  const location = useLocation()
  const validationSchema = Yup.object().shape({
    awbNo: Yup.string().when('shippingPartner', {
      is: (value) => value.toLowerCase() === 'system',
      then: () => Yup.string().required('Awb number required'),
      otherwise: () => Yup.string().notRequired()
    }),
    courierName: Yup.string().required('Courier name required'),
    length: Yup.string().required('length required'),
    width: Yup.string().required('Width required'),
    height: Yup.string().required('Height required')
  })

  const onSubmit = async (values) => {
    Swal.fire({
      title: 'Confirm Shipping',
      text: 'Are you sure you want to ship this item?',
      icon: 'question',
      showCancelButton: _SwalDelete.showCancelButton,
      confirmButtonColor: _SwalDelete.confirmButtonColor,
      cancelButtonColor: _SwalDelete.cancelButtonColor,
      confirmButtonText: 'Yes, Ship Item',
      cancelButtonText: 'No, Keep Reviewing'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true)
          const response = await axiosProvider({
            method: 'POST',
            endpoint: 'ManageOrder/OrderShip',
            data: values,
            location: location?.pathname,
            userId: userInfo?.userId
          })
          setLoading(false)
          if (response?.status === 200) {
            setModalShow({ show: false, type: '', data: null })
            showToast(toast, setToast, response)

            const order = await fetchOrderData(
              `?searchText=${encodedSearchText(
                filterDetails?.searchText
              )}&pageIndex=${filterDetails?.pageIndex}&pageSize=${
                filterDetails?.pageSize
              }`,
              toast,
              setToast
            )

            if (order?.status === 200) {
              getOrderItems(values?.orderID, order?.data?.data)
            }
          }
        } catch {
          showToast(toast, setToast, {
            data: {
              message: _exception?.message,
              code: 204
            }
          })
        }
      }
    })
  }

  return (
    <ModelComponent
      show={modalShow?.show}
      modalsize={'md'}
      modalheaderclass={''}
      className='modal-backdrop'
      modeltitle={'Ship order'}
      onHide={() => {
        setInitialValues(initVal)
        setModalShow({ show: !modalShow?.show, data: null, type: '' })
      }}
      btnclosetext={''}
      closebtnvariant={''}
      backdrop={'static'}
      formbuttonid={'ship'}
      submitname={'Ship order'}
    >
      <Formik
        enableReinitialize
        initialValues={initialValues?.ship}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ values, setFieldValue }) => (
          <Form id='ship'>
            <div className='row'>
              <div className='col-md-12 mb-3'>
                <label
                  className='form-label required'
                  htmlFor='shippingPartner'
                >
                  Shipping Partner
                </label>
                <ReactSelect
                  id='shippingPartner'
                  name='shippingPartner'
                  isClearable={true}
                  placeholder='Select Shipping Partner'
                  value={
                    values?.shippingPartner && {
                      value: values?.shippingPartner,
                      label: values?.shippingPartner
                    }
                  }
                  options={[
                    { label: 'System', value: 'System' },
                    { label: 'DHL', value: 'DHL' }
                  ]}
                  onChange={(e) => {
                    setFieldValue('shippingPartner', e?.value)
                    if (e?.value?.toLowerCase() !== 'system') {
                      setFieldValue('courierName', e?.value)
                    } else {
                      setFieldValue('courierName', '')
                    }
                  }}
                />
              </div>

              {values?.shippingPartner?.toLowerCase() === 'system' && (
                <>
                  <div className='col-md-6 mb-3'>
                    <label className='form-label required' htmlFor='awbNo'>
                      AWB Number
                    </label>
                    <InputGroup>
                      <frm.Control
                        name='awbNo'
                        value={values?.awbNo}
                        id='awbNo'
                        placeholder='AWB Number'
                        onChange={(e) => {
                          changeHandler(
                            'awbNo',
                            e?.target?.value,
                            setFieldValue
                          )
                        }}
                        onBlur={(e) => {
                          let fieldName = e?.target?.name
                          setFieldValue(fieldName, values[fieldName]?.trim())
                        }}
                      />
                    </InputGroup>
                    <ErrorMessage name='awbNo' component={TextError} />
                  </div>
                  <div className='col-md-6 mt-4'>
                    <div className='input-file-wrapper'>
                      <Button
                        variant='primary'
                        className='fw-semibold w-100 text-center'
                        onClick={() => {
                          setFieldValue('awbNo', generateSawbNumber())
                        }}
                      >
                        Generate Random AWB No
                      </Button>
                    </div>
                  </div>
                </>
              )}

              <div className='col-md-6'>
                <label className='form-label required' htmlFor='courierName'>
                  Courier Name
                </label>
                <InputGroup>
                  <frm.Control
                    name='courierName'
                    value={values?.courierName}
                    id='courierName'
                    placeholder='Courier Name'
                    disabled={
                      values?.shippingPartner?.toLowerCase() !== 'system'
                    }
                    onChange={(e) => {
                      changeHandler(
                        'courierName',
                        e?.target?.value,
                        setFieldValue
                      )
                    }}
                    onBlur={(e) => {
                      let fieldName = e?.target?.name
                      setFieldValue(fieldName, values[fieldName]?.trim())
                    }}
                  />
                </InputGroup>
                <ErrorMessage name='courierName' component={TextError} />
              </div>

              <div className='col-md-4 mb-3'>
                <label className='form-label required' htmlFor='pl'>
                  Length
                </label>
                <InputGroup>
                  <frm.Control
                    name='length'
                    id='length'
                    value={values['length']}
                    placeholder='Length'
                    onChange={(e) => {
                      const inputValue = e.target.value
                      const regex = /^[0-9\b]+$/
                      if (inputValue === '' || regex.test(inputValue)) {
                        setFieldValue('length', e?.target?.value)
                      }
                    }}
                    onBlur={() => {
                      if (
                        values['length'] &&
                        values?.breadth &&
                        values?.height
                      ) {
                        let data = {
                          length: values['length'],
                          breadth: values?.breadth,
                          height: values?.height
                        }
                        fetchCalculation(
                          'Product/CalculatePackagingWeight',
                          data,
                          (data) => {
                            setFieldValue('weight', data?.packaging_weight)
                          }
                        )
                      }
                    }}
                    maxLength={4}
                  />
                  <InputGroup.Text>CM</InputGroup.Text>
                </InputGroup>
                <ErrorMessage name='length' component={TextError} />
              </div>

              <div className='col-md-4 mb-3'>
                <label className='form-label required' htmlFor='pb'>
                  Breadth
                </label>
                <InputGroup>
                  <frm.Control
                    name='width'
                    id='width'
                    placeholder='Width'
                    value={values?.width}
                    onChange={(e) => {
                      const inputValue = e.target.value
                      const regex = /^[0-9\b]+$/
                      if (inputValue === '' || regex.test(inputValue)) {
                        setFieldValue('width', e?.target?.value)
                      }
                    }}
                    onBlur={() => {
                      if (values['length'] && values?.width && values?.height) {
                        let data = {
                          length: values['length'],
                          breadth: values?.width,
                          height: values?.height
                        }
                        fetchCalculation(
                          'Product/CalculatePackagingWeight',
                          data,
                          (data) => {
                            setFieldValue('weight', data?.packaging_weight)
                          }
                        )
                      }
                    }}
                    maxLength={4}
                  />
                  <InputGroup.Text>CM</InputGroup.Text>
                </InputGroup>

                <ErrorMessage name='width' component={TextError} />
              </div>

              <div className='col-md-4 mb-3'>
                <label className='form-label required' htmlFor='ph'>
                  Height
                </label>
                <InputGroup>
                  <frm.Control
                    name='height'
                    id='height'
                    value={values?.height}
                    placeholder='Height'
                    onChange={(e) => {
                      const inputValue = e.target.value
                      const regex = /^[0-9\b]+$/
                      if (inputValue === '' || regex.test(inputValue)) {
                        setFieldValue('height', e?.target?.value)
                      }
                    }}
                    onBlur={() => {
                      if (values['length'] && values?.width && values?.height) {
                        let data = {
                          length: values['length'],
                          breadth: values?.width,
                          height: values?.height
                        }
                        fetchCalculation(
                          'Product/CalculatePackagingWeight',
                          data,
                          (data) => {
                            setFieldValue('weight', data?.packaging_weight)
                          }
                        )
                      }
                    }}
                    maxLength={4}
                  />
                  <InputGroup.Text>CM</InputGroup.Text>
                </InputGroup>

                <ErrorMessage name='height' component={TextError} />
              </div>

              <div className='col-md-4 mb-3'>
                <label className='form-label' htmlFor='pweight'>
                  Weight
                </label>
                <InputGroup>
                  <frm.Control
                    name='weight'
                    disabled
                    value={values?.weight}
                    id='weight'
                    placeholder='Weight'
                    onChange={(e) => {
                      changeHandler('weight', e?.target?.value, setFieldValue)
                    }}
                  />
                  <InputGroup.Text>KG</InputGroup.Text>
                </InputGroup>
              </div>

              <div className='col-md-8 mb-3'>
                <label className='form-label' htmlFor='packageDescription'>
                  Package Description
                </label>
                <InputGroup>
                  <frm.Control
                    name='packageDescription'
                    value={values?.packageDescription}
                    id='packageDescription'
                    placeholder='Package Description'
                    onChange={(e) => {
                      changeHandler(
                        'packageDescription',
                        e?.target?.value,
                        setFieldValue
                      )
                    }}
                    onBlur={(e) => {
                      let fieldName = e?.target?.name
                      setFieldValue(fieldName, values[fieldName]?.trim())
                    }}
                  />
                </InputGroup>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </ModelComponent>
  )
}

export default ShipOrder
